import qs from 'qs'
import axios from '../config/axios.js'
let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } };
let configV1 = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } };
let configV2 = { headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' } };
const BASE_URL = '/api/college_manage'
export const questionServer = {
  questionList: (params) => {
    return axios.get(`${BASE_URL}/question/query`, {params: params}).then(res => res.data)
  },
  questionDetail: (params) => {
    return axios.get(`${BASE_URL}/question/getById`, {params: params}).then(res => res.data)
  },
  questionAdd: (params) => {
    return axios.post(`${BASE_URL}/question/add`, params, {skipErrorHandling: true}, configV1).then(res => res.data)
  },
  questionUpdate: (params) => {
    return axios.post(`${BASE_URL}/question/update`, params, {skipErrorHandling: true}, configV1).then(res => res.data)
  },
  questionDel: (params) => {
    return axios.post(`${BASE_URL}/question/delete`, qs.stringify(params), config).then(res => res.data)
  },
  questionimport: (params) => {
    return axios.post(`${BASE_URL}/question/importExcel`, params, configV2).then(res => res.data)
  },
}
export const vedioServer = {
  vedioList: (params) => {
    return axios.get(`${BASE_URL}/vedioResource/query`, {params: params}).then(res => res.data)
  },
  vedioDetail: (params) => {
    return axios.get(`${BASE_URL}/vedioResource/getById`, {params: params}).then(res => res.data)
  },
  vedioAdd: (params) => {
    return axios.post(`${BASE_URL}/vedioResource/add`, qs.stringify(params), {skipErrorHandling: true}, config).then(res => res.data)
  },
  vedioUpdate: (params) => {
    return axios.post(`${BASE_URL}/vedioResource/update`, qs.stringify(params), {skipErrorHandling: true}, config).then(res => res.data)
  },
  vedioDel: (params) => {
    return axios.post(`${BASE_URL}/vedioResource/delete`, qs.stringify(params), config).then(res => res.data)
  }
}
export const coursewareServer = {
  coursewareList: (params) => {
    return axios.get(`${BASE_URL}/coursewareResource/query`, {params: params}).then(res => res.data)
  },
  coursewareDetail: (params) => {
    return axios.get(`${BASE_URL}/coursewareResource/getById`, {params: params}).then(res => res.data)
  },
  coursewareAdd: (params) => {
    return axios.post(`${BASE_URL}/coursewareResource/add`, qs.stringify(params), {skipErrorHandling: true}, config).then(res => res.data)
  },
  coursewareUpdate: (params) => {
    return axios.post(`${BASE_URL}/coursewareResource/update`, qs.stringify(params), {skipErrorHandling: true}, config).then(res => res.data)
  },
  coursewareDel: (params) => {
    return axios.post(`${BASE_URL}/coursewareResource/delete`, qs.stringify(params), config).then(res => res.data)
  }
}
export const caseServer = {
  caseList: (params) => {
    return axios.get(`${BASE_URL}/study/query`, {params: params}).then(res => res.data)
  },
  caseDetail: (params) => {
    return axios.get(`${BASE_URL}/study/getById`, {params: params}).then(res => res.data)
  },
  caseAdd: (params) => {
    return axios.post(`${BASE_URL}/study/add`, qs.stringify(params), {skipErrorHandling: true}, config).then(res => res.data)
  },
  caseUpdate: (params) => {
    return axios.post(`${BASE_URL}/study/update`, qs.stringify(params), {skipErrorHandling: true}, config).then(res => res.data)
  },
  caseDel: (params) => {
    return axios.post(`${BASE_URL}/study/delete`, qs.stringify(params), config).then(res => res.data)
  }
}
export const packgeServer = {
  questions: (params) => {
    return axios.get(`${BASE_URL}/question/coursePacks/query`, {params: params}).then(res => res.data)
  },
  questionSort: (params) => {
    return axios.post(`${BASE_URL}/question/coursePacks/uptQuestionSort`, params, configV1).then(res => res.data)
  },
  vedios: (params) => {
    return axios.get(`${BASE_URL}/vedioResource/coursePacks/query`, {params: params}).then(res => res.data)
  },
  vedioSort: (params) => {
    return axios.post(`${BASE_URL}/vedioResource/coursePacks/uptSort`, params, configV1).then(res => res.data)
  },
  coursewares: (params) => {
    return axios.get(`${BASE_URL}/coursewareResource/coursePacks/query`, {params: params}).then(res => res.data)
  },
  coursewareSort: (params) => {
    return axios.post(`${BASE_URL}/coursewareResource/coursePacks/uptSort`, params, configV1).then(res => res.data)
  },
  cases: (params) => {
    return axios.get(`${BASE_URL}/study/coursePacks/query`, {params: params}).then(res => res.data)
  },
  caseSort: (params) => {
    return axios.post(`${BASE_URL}/study/coursePacks/uptSort`, params, configV1).then(res => res.data)
  },
}


// WEBPACK FOOTER //
// ./src/api/server/resource.js